import { render, staticRenderFns } from "./MaintenancePlans.vue?vue&type=template&id=2013af72&scoped=true"
import script from "./MaintenancePlans.vue?vue&type=script&lang=js"
export * from "./MaintenancePlans.vue?vue&type=script&lang=js"
import style0 from "./MaintenancePlans.vue?vue&type=style&index=0&id=2013af72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2013af72",
  null
  
)

export default component.exports